import React from 'react';
import StyledHomeBanner from './styles';

const HomeBanner = () => (
  <StyledHomeBanner>
    <a
      href="https://sendgrid.com/solutions/email-api/deliverability-insights/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Monitor and optimize email program health with Deliverability Insights-now in Public Beta!
    </a>
    <a
      type="button"
      href="https://sendgrid.com/solutions/email-api/deliverability-insights/"
      className="btn--primary"
    >
      Learn More
    </a>          
  </StyledHomeBanner>
);

export default HomeBanner;

export const query = graphql`
  fragment HomePageFragment on WPGraphQL_Page {
    acfPageHome {
      showHomeBanner
    }
  }
`;
